import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

/**
 * Page d'information affichée lorsque l'utilisateur a explicitement refusé
 * le consentement applicatif RGPD (S6-5, GAP-2, R-13).
 *
 * Le bouton « Revenir à l'accueil » route vers `/`. Comme `consent_given_at`
 * est toujours `null` côté backend, la modale `ConsentModal` réapparaitra
 * automatiquement dans le layout racine — le user peut accepter à tout
 * moment.
 */
export function ConsentRefused(): JSX.Element {
  return (
    <div className="mx-auto max-w-xl py-8">
      <Card className="space-y-4 p-6">
        <h1 className="text-xl font-semibold tracking-tight text-slate-900">
          Vous avez refusé le consentement
        </h1>
        <p className="text-sm leading-relaxed text-slate-700">
          SunMatch n'est utilisable qu'avec votre consentement explicite au
          traitement de vos données (RGPD art. 7). Sans ce consentement, le
          calculateur d'autoconsommation ne peut pas fonctionner.
        </p>
        <p className="text-sm leading-relaxed text-slate-700">
          Aucune donnée vous concernant n'a été enregistrée. Vous pouvez revenir
          à tout moment pour accepter et démarrer une simulation.
        </p>
        <div className="pt-2">
          <Button asChild variant="default">
            <Link to="/">Revenir à l'accueil</Link>
          </Button>
        </div>
      </Card>
    </div>
  );
}
